
<template>    
  
  <p v-if="!auth.is_ready">Carregando...</p>
  <DefaultLayout v-else-if="auth.check()"></DefaultLayout>
  <LoginLayout v-else></LoginLayout>
</template>
<script setup lang="ts">

import DefaultLayout from './layouts/DefaultLayout.vue';
import LoginLayout from './layouts/LoginLayout.vue';
import { useAuth } from '@/plugins/auth'

const auth = useAuth()



</script>